"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupIntlTelUtils = exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
require("intl-tel-input/build/css/intlTelInput.css");
require("./IntlTelInput.css");
var _intlTelInput2 = _interopRequireDefault(require("intl-tel-input"));
var _vanillaTextMask = _interopRequireDefault(require("vanilla-text-mask"));
var _ = _interopRequireDefault(require("./"));
var _excluded = ["autoFocus", "onChange", "onBlur", "value", "enabledCountries"],
  _excluded2 = ["standalone"]; // $FlowFixMe
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var UTILS_SCRIPT = 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.12/js/utils.js';
var createEvent = function createEvent(intlTelRef) {
  var countryData = intlTelRef.getSelectedCountryData();
  var target = intlTelRef.telInput;
  var value = target.value.replace(/[^0-9]/g, '');
  return {
    target: target,
    countryData: countryData,
    value: value.length === 0 ? '' : "+".concat(countryData.dialCode).concat(value),
    isValidNumber: intlTelRef.isValidNumber()
  };
};
var View = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus,
    onChange = _ref.onChange,
    onBlur = _ref.onBlur,
    value = _ref.value,
    enabledCountries = _ref.enabledCountries,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var inputRef = (0, _react.useRef)();
  var intlTelInputRef = (0, _react.useRef)();
  var valueRef = (0, _react.useRef)('');
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    placeholder = _useState2[0],
    setPlaceholder = _useState2[1];
  var dispatchOnChange = (0, _react.useCallback)(function (event) {
    if (event.value !== valueRef.current) {
      valueRef.current = event.value;
      if (onChange) onChange(event);
    }
  }, [onChange]);
  (0, _react.useEffect)(function () {
    // INFO: setup intl-tel-input plugin
    intlTelInputRef.current = (0, _intlTelInput2["default"])(inputRef.current, {
      utilsScript: UTILS_SCRIPT,
      placeholderNumberType: 'MOBILE',
      dropdownContainer: document.body,
      formatOnDisplay: true,
      separateDialCode: false,
      customPlaceholder: function customPlaceholder(selectedCountryPlaceholder) {
        setPlaceholder(selectedCountryPlaceholder);
        return selectedCountryPlaceholder;
      },
      onlyCountries: enabledCountries || []
    });
    intlTelInputRef.current.promise.then(function () {
      if (value) {
        intlTelInputRef.current.setNumber(value);
      }
    });
    return function () {
      intlTelInputRef.current && intlTelInputRef.current.destroy();
    };
  }, []);
  (0, _react.useEffect)(function () {
    // INFO: setup the masked input based on the placeholder
    if (inputRef.current) {
      var maskedInputCdontroller = (0, _vanillaTextMask["default"])({
        inputElement: inputRef.current,
        mask: placeholder.split('').map(function (item) {
          return Number.isNaN(Number.parseInt(item)) ? item : /\d/;
        }),
        placeholderChar: "\u2000"
      });
      return function () {
        maskedInputCdontroller.destroy();
      };
    }
  }, [placeholder]);
  (0, _react.useEffect)(function () {
    // INFO: handle the autoFocus prop
    if (autoFocus && inputRef.current) {
      inputRef.current.focus();
    }
  }, [autoFocus]);
  (0, _react.useEffect)(function () {
    // INFO: setup onChange event
    if (intlTelInputRef.current) {
      var target = intlTelInputRef.current.telInput;
      var handleOnChange = function handleOnChange(e) {
        var event = createEvent(intlTelInputRef.current);
        dispatchOnChange(event);
      };
      target === null || target === void 0 || target.addEventListener('keyup', handleOnChange);
      return function () {
        target === null || target === void 0 || target.removeEventListener('keyup', handleOnChange);
      };
    }
  }, [dispatchOnChange]);
  (0, _react.useEffect)(function () {
    // INFO: setup onBlur event
    if (intlTelInputRef.current) {
      var target = intlTelInputRef.current.telInput;
      var handleOnBlur = function handleOnBlur(e) {
        var event = createEvent(intlTelInputRef.current);
        if (onBlur) onBlur(event);
      };
      target === null || target === void 0 || target.addEventListener('blur', handleOnBlur);
      return function () {
        return target === null || target === void 0 ? void 0 : target.removeEventListener('blur', handleOnBlur);
      };
    }
  }, [onBlur]);
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      getNumber: function getNumber() {
        var _intlTelInputRef$curr;
        for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
          rest[_key] = arguments[_key];
        }
        return (_intlTelInputRef$curr = intlTelInputRef.current) === null || _intlTelInputRef$curr === void 0 ? void 0 : _intlTelInputRef$curr.getNumber.apply(_intlTelInputRef$curr, rest);
      },
      getCountryData: function getCountryData() {
        var _intlTelInputRef$curr2;
        return (_intlTelInputRef$curr2 = intlTelInputRef.current) === null || _intlTelInputRef$curr2 === void 0 ? void 0 : _intlTelInputRef$curr2.getSelectedCountryData();
      },
      getNumberType: function getNumberType() {
        var _intlTelInputRef$curr3;
        for (var _len2 = arguments.length, rest = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          rest[_key2] = arguments[_key2];
        }
        return (_intlTelInputRef$curr3 = intlTelInputRef.current) === null || _intlTelInputRef$curr3 === void 0 ? void 0 : _intlTelInputRef$curr3.getNumberType.apply(_intlTelInputRef$curr3, rest);
      },
      isValidNumber: function isValidNumber() {
        var _intlTelInputRef$curr4;
        return (_intlTelInputRef$curr4 = intlTelInputRef.current) === null || _intlTelInputRef$curr4 === void 0 ? void 0 : _intlTelInputRef$curr4.isValidNumber();
      }
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_["default"], (0, _extends2["default"])({}, props, {
    standalone: true,
    type: "tel",
    ref: inputRef,
    style: {
      width: '100%',
      border: 0
    }
  }));
});
var IntlTelInput = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$standalone = _ref2.standalone,
    standalone = _ref2$standalone === void 0 ? true : _ref2$standalone,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  if (standalone) {
    return /*#__PURE__*/_react["default"].createElement(View, (0, _extends2["default"])({}, props, {
      ref: ref
    }));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
      name: props.name,
      render: function render(_ref3) {
        var field = _ref3.field,
          form = _ref3.form;
        return /*#__PURE__*/_react["default"].createElement(IntlTelInput, (0, _extends2["default"])({}, props, {
          ref: ref,
          value: field.value,
          onBlur: function onBlur(e) {
            form.setFieldTouched(props.name);
            props.onBlur && props.onBlur(e);
          },
          onChange: function onChange(e) {
            form.setFieldValue(props.name, e.value);
            props.onChange && props.onChange(e);
          }
        }));
      }
    });
  }
});

// FIXME: type the intl-tel utils
var setupIntlTelUtils = exports.setupIntlTelUtils = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          if (!window.intlTelInputUtils) {
            _context.next = 5;
            break;
          }
          return _context.abrupt("return", window.intlTelInputUtils);
        case 5:
          if (!window.intlTelInputGlobals) {
            _context.next = 11;
            break;
          }
          _context.next = 8;
          return window.intlTelInputGlobals.loadUtils(UTILS_SCRIPT);
        case 8:
          return _context.abrupt("return", window.intlTelInputUtils);
        case 11:
          throw new Error('intlTelInputGlobals is not initialled');
        case 12:
          _context.next = 17;
          break;
        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          console.error(_context.t0);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 14]]);
  }));
  return function setupIntlTelUtils() {
    return _ref4.apply(this, arguments);
  };
}();
var _default = exports["default"] = IntlTelInput;
//# sourceMappingURL=IntlTelInput.js.map